export const environment = {
  production: true,
  buildId: '2900203562719731',
  configFile: 'config.json',
};
